module.exports = __webpack_public_path__ + "img/lamp.e3ed29a9.png";